import React, {useState} from "react";
import "./footer.scss";
import logo from "../../media/Logo.png";
import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FaArrowsUpToLine} from "react-icons/fa6";
import {faArrowsUpToLine} from "@fortawesome/free-solid-svg-icons/faArrowsUpToLine";
import {
  faArrowCircleUp,
  faArrowUp,
  faArrowUp19,
} from "@fortawesome/free-solid-svg-icons";
import {FaArrowUp} from "react-icons/fa";

const Footer = () => {
  const [isOpen] = useState(false);
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo"></div>
        <div className={isOpen ? "menus active" : "menus"}>
          {" "}
          Website Map
          <ul>
            <li>
              <HashLink className="link" smooth to="#about">
                About
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#promo">
                Promo
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#rumah">
                Residentials
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#apartement">
                Apartement
              </HashLink>
            </li>
            <li>
              <HashLink className="link" smooth to="#ruko">
                Ruko Commercials
              </HashLink>
            </li>
          </ul>
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Summarecon Serpong</h2>
            <h3>
              Ruko Boulevard CBD, Jl. Gading Serpong Boulevard M5 No.28, Jl.
              Gading Serpong Boulevard No.28, Curug Sangereng, Kec. Klp. Dua,
              Kabupaten Tangerang, Banten 15810
            </h3>
            <h4>Contact us : +6285215127964</h4>
            <Link to="/privacy-policy">
              <div className="footer-contact">Privacy Policy</div>
            </Link>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <hr color="white" />
      <div className="container-bawah">
        <div className="rights">All rights reserved</div>
        <div className="judulcontainerbawah">
          <div className="copyright">© Summarecon Serpong</div>
          <div className="powered">Powered by Linktown</div>
        </div>
        <div className="backtotop">
          <ul>
            <li>
              <HashLink className="link" smooth to="#navbar">
                Back to Top
              </HashLink>
            </li>
          </ul>
          <FontAwesomeIcon icon={faArrowCircleUp} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
